
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/privacy/regulations",
      function () {
        return require("private-next-pages/terms/privacy/regulations.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/privacy/regulations"])
      });
    }
  